import React, {
  useMemo,
  useEffect,
  createContext,
  useContext,
  useState
} from 'react';
import io from 'socket.io-client';
import store from '../store';
import {
  addUnAnsweredConversation,
  removeUnAnsweredConversation
} from 'store/action/unanswered-convertations-action';
import { updateContactNameOnConversation } from 'store/action/contact-events-actions';

import { addTagsConversationInAttendance } from '../../src/store/action/conversation-in-attendance-action';

import { removeAnsweredConversation } from 'store/action/answered-conversations-action';
import { alterContactNameOnConversation } from 'store/action/answered-conversations-action';
import { checkRemoveConversationInAttendance } from 'store/action/conversation-in-attendance-action';
import { updateAllMonitoringQueueChat } from 'store/action/monitoring-chat-actions';
import { updateMonitoringQueueChat } from 'store/action/monitoring-chat-actions';
import { EVENTS_EMIT } from './useSocketConversationChatTs';
import { PlayNewAlert } from 'components/Notifications/components/Alerts';
import ConfigurationService from 'views/SystemParams/services/index';
import { useSocketEvents, wrapSocketWithGlobalLoader } from './socket-utils';

const useSocketAdmConversationContext = createContext();

const EVENTS_SOCKET_ADM = {
  UPDATE_ALL_MONITORING_SYNTHETIC_CHAT: 'UPDATE_ALL_MONITORING_SYNTHETIC_CHAT',
  UPDATE_MONITORING_SYNTHETIC_CHAT: 'UPDATE_MONITORING_SYNTHETIC_CHAT',
  UPDATE_CHAT_IN_MONITORING: 'update_chat_in_monitoring'
};

export function SocketAdmConversationProvider({ children }) {
  const socketAdm = useMemo(() => {
    return wrapSocketWithGlobalLoader(
      io.connect(process.env.REACT_APP_PROXY_URL, {
        path: process.env.REACT_APP_CHANNEL_ADM_SOCKET_PATH,
        transports: ['websocket'],
        upgrade: false
      })
    );
  }, []);

  useEffect(() => {
    return () => {
      socketAdm.close();
    };
  }, [socketAdm]);

  useSocketEvents(socketAdm, {
    entrou_na_fila: (data) => {
      const attendantQueues = JSON.parse(
        localStorage.getItem('queues') ?? '[]'
      );
      attendantQueues.forEach((attendantQueue) => {
        if (data.conversa?.fila && data.conversa.fila === attendantQueue.name) {
          store.dispatch(addUnAnsweredConversation(data.conversa));
        }
      });
    },
    remove_conversa_fila: async (data) => {
      await store.dispatch(removeUnAnsweredConversation(data));
    },
    contact_update_name: async (data) => {
      await store.dispatch(updateContactNameOnConversation(data));
      await store.dispatch(alterContactNameOnConversation(data));
    },
    CONTACT_UPDATE_TAG: async (data) => {
      await store.dispatch(addTagsConversationInAttendance(data));
    },
    remove_chat_from_monitoring: async () => {},
    remove_chat_from_all_agents: async (chatID) => {
      await store.dispatch(removeAnsweredConversation(chatID));
      await store.dispatch(removeUnAnsweredConversation(chatID));
      await store.dispatch(checkRemoveConversationInAttendance(chatID));
    },
    [EVENTS_SOCKET_ADM.UPDATE_CHAT_IN_MONITORING]: async () => {},
    [EVENTS_SOCKET_ADM.UPDATE_ALL_MONITORING_SYNTHETIC_CHAT]: async (data) => {
      store.dispatch(updateAllMonitoringQueueChat(data));
    },
    [EVENTS_SOCKET_ADM.UPDATE_MONITORING_SYNTHETIC_CHAT]: async (data) => {
      store.dispatch(updateMonitoringQueueChat(data));
    }
  });

  const [audioNotification, setAudioNotification] = useState(null);

  useEffect(() => {
    ConfigurationService.getAllConfigs()
      .then((response) => {
        setAudioNotification(response.data.audio_chat);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useSocketEvents(socketAdm, {
    [EVENTS_EMIT.SHOW_POPUP_TO_AGENT]: (data) => {
      if (!audioNotification || !data?.message || !data?.type) return;

      let permission = window.Notification.permission;

      if (data.playAudio) {
        PlayNewAlert({
          data: '__purposefully__mocked__falsy__value__',
          areDesktopNotificationsAllowed: permission,
          type: null,
          audioNotificationURL: audioNotification,
          isNotificationScheduling: false,
          message: data.message,
          toastData: {
            type: data.type,
            message: data.message,
            action: data.action,
            playAudio: data.playAudio
          }
        });
      } else {
        PlayNewAlert({
          data: data.message,
          areDesktopNotificationsAllowed: permission,
          audioNotificationURL: audioNotification,
          isNotificationScheduling: false,
          playAudio: false,
          toastData: data
        });
      }
    }
  });

  return (
    <>
      <useSocketAdmConversationContext.Provider
        value={{
          socketAdm: socketAdm
        }}
      >
        {children}
      </useSocketAdmConversationContext.Provider>
    </>
  );
}

export function useConectionSocketAdmConversation() {
  const context = useContext(useSocketAdmConversationContext);
  return context;
}
